import { AddressCreateDto, AddressUpdateDto } from "../../../api";
import AddressModalForm from "../addressModalForm/addressModalForm";

export default function AddressModalFormAddContainer(props: AddressModalFormAddContainerProps) {
    return <>
        <AddressModalForm
            isModalVisible={props.addFormVisibility}
            setModalVisibility={props.onFinish}
            onSubmit={props.onSubmit}
            modalTitle={props.title}
            saveButtonTitle="Zapisz"
            initialValues={props.AddressToEdit!}
        />
    </>
}

interface AddressModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: AddressCreateDto | AddressUpdateDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    AddressToEdit: AddressUpdateDto | null
}
